import styles from './NetworkSymbologyCheckbox.module.scss';
import { useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { mdiHelpCircleOutline, mdiMapLegend } from '@mdi/js';
import Icon from '@mdi/react';
import GasSymbologyIcon from 'client/components/aria/Icons/GasSymbologyIcon/GasSymbologyIcon';
import Tooltip from 'client/components/aria/Tooltip/Tooltip';
import { useOwnerSectorSymbology } from '../OwnerPreferences';
import Checkbox from 'client/components/aria/Checkbox/Checkbox';
import { sectors } from 'client/store/layersSlice/layersSlice';
import ElectricitySymbologyIcon from 'client/components/aria/Icons/ElectricitySymbologyIcon/ElectricitySymbologyIcon';
import { useDispatch } from 'react-redux';
import Button from 'client/components/aria/Button/Button';
import { setShowDynamicLegend } from 'client/store/mapSlice/mapSlice';

const SECTOR_ICONS = {
    [sectors.ELECTRICITY]: <ElectricitySymbologyIcon />,
    [sectors.GAS]: <GasSymbologyIcon />
};

const NetworkSymbologyCheckbox = ({ category, selectedCategory, sector, onlyHasOneCategory, ownerId, dataTestId }) => {
    const shouldShowSymbologyCheckbox = (category, sector, onlyHasOneCategory) => {
        return (selectedCategory === category.en || onlyHasOneCategory) &&
            category.en.toLowerCase() === sector.toLowerCase();
    };

    const { sectorSymbology, toggleSector } = useOwnerSectorSymbology(ownerId);
    const [isTooltipOpen, setIsTooltipOpen] = useState(false);
    const tooltipTriggerRef = useRef(null);
    const dispatch = useDispatch();

    if (!shouldShowSymbologyCheckbox(category, sector, onlyHasOneCategory)) {
        return null;
    }
    const checkboxIsSelected = sectorSymbology[sector];
    return <>
        <div className={styles.checkboxWithIcon}>
            <Checkbox
                variant='xs'
                id={`${ownerId}.checkbox.${sector.toLowerCase()}`}
                isSelected={checkboxIsSelected}
                onChange={() => toggleSector(sector)}
                className={styles.symbologyCheckbox}
                data-testid={dataTestId}
            >
                <FormattedMessage id={`isolatedViews.networks.symbology.${sector}`} />
            </Checkbox>

            <div
                ref={tooltipTriggerRef}
                className={styles.tooltipTrigger}
                onClick={() => setIsTooltipOpen(true)}
                onMouseEnter={() => setIsTooltipOpen(true)}
                onMouseLeave={() => setIsTooltipOpen(false)}
                data-testid={`${dataTestId}.tooltip`}
            >
                {SECTOR_ICONS[sector]}
                <div className={styles.tooltipWrapper}>
                    <Icon
                        path={mdiHelpCircleOutline}
                        size={0.75}
                    />
                    <Tooltip
                        isOpen={isTooltipOpen}
                        triggerRef={tooltipTriggerRef}
                        onClose={() => setIsTooltipOpen(false)}
                        className={styles.tooltip}
                        contentClassName={styles.tooltipContent}
                    >
                        <FormattedMessage id='isolatedViews.networks.tooltip' />
                    </Tooltip>
                </div>
            </div>
        </div>
        {checkboxIsSelected && <Button
            variant='unstyled'
            className={styles.legendButtonWrapper}
            aria-label={category.en}
            onPress={() => dispatch(setShowDynamicLegend(true))}
            data-testid={`${dataTestId}.legendButton`}
            elementType='button'
        >
            <div className={styles.dynamicLegendIcon} aria-hidden='true'>
                <Icon path={mdiMapLegend} size={0.75} />
            </div>
            <FormattedMessage id='isolatedViews.networks.legendButton' />
        </Button>}
    </>;
};

export default NetworkSymbologyCheckbox;
